import { render } from "./sms-template.vue?vue&type=template&id=643a995d"
import script from "./sms-template.vue?vue&type=script&lang=js"
export * from "./sms-template.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__